import { LoginSysAdmin } from '../../../role/components/login-sys-admin'
import { LayoutAdminNode } from './admin-node/layout-admin-node'
import { LayoutApp } from './app/layout-app'
import { LayoutAuthSession } from './auth-session/route-auth-session'
import { LayoutDeviceLoginDenial } from './device-login-denial/route-device-login-denial'
import { LayoutDashboard } from './dashboard/layout-dashboard'
import { LayoutLogin } from './login/layout-login'
import { LayoutOrganization } from './organization/layout-organization'
import { LayoutProvider } from './provider/layout-provider'
import { LayoutSigninMethod } from './signin-method/layout-signin-method'
import { LayoutEmailActivity } from './email-activity/layout-email-activity'
import { LayoutRequestLog } from './request-log/route-request-log'
import { LayoutErrors } from './errors/route-errors'
import { LayoutSysAuditLog } from './audit-log/route-audit-log-sys'
import { LayoutAuditRetention } from './audit-retention/route-audit-retention'
import { LayoutAlertRouting } from './alert-routing/route-alert-routing'
import { LayoutSysApiKeys } from './api-keys/route-api-keys'
import { LayoutAiTools, LayoutAiToolsNoStaff } from './ai-tools/route-ai-tools'
import { LayoutConsentLog } from './consent-log/route-consent-log'
import { LayoutNotify } from './notify/route-notify'

export const LayoutAdmin = () => {
  return (
    <LoginSysAdmin fallback={<LayoutAiToolsNoStaff />}>
      <LayoutDashboard />
      <LayoutApp />
      <LayoutAuthSession />
      <LayoutDeviceLoginDenial />
      <LayoutLogin />
      <LayoutEmailActivity />
      <LayoutRequestLog />
      <LayoutErrors />
      <LayoutSysAuditLog />
      <LayoutAuditRetention />
      <LayoutAlertRouting />
      <LayoutSysApiKeys />
      <LayoutAiTools />
      <LayoutConsentLog />
      <LayoutNotify />
      <LayoutProvider />
      <LayoutSigninMethod />
      <LayoutOrganization />
      <LayoutAdminNode />
    </LoginSysAdmin>
  )
}
